// Groups a Group Owner/Admin login manages, and which one is selected in the portal.
// Only the list and the selected group_id are stored; the selected group's name is always read from the list.
const GROUPS_KEY = 'group_portal_groups';
const SELECTED_GROUP_KEY = 'group_portal_selected_group_id';
// Written by earlier builds, when signin returned a top-level group_id / group_name.
const LEGACY_KEYS = ['group_id', 'group_name'];

export const NO_GROUPS_MESSAGE = 'Your access to this group has been removed. Contact your provider.';

export const getStoredGroups = () => {
  try {
    const groups = JSON.parse(localStorage.getItem(GROUPS_KEY) || '[]');
    return Array.isArray(groups) ? groups : [];
  } catch (e) {
    return [];
  }
};

export const storeGroups = groups => {
  localStorage.setItem(GROUPS_KEY, JSON.stringify(Array.isArray(groups) ? groups : []));
};

export const getSelectedGroupId = () => {
  const id = parseInt(localStorage.getItem(SELECTED_GROUP_KEY), 10);
  return Number.isInteger(id) && id > 0 ? id : null;
};

export const selectGroup = group => {
  localStorage.setItem(SELECTED_GROUP_KEY, group.group_id);
};

// Keeps the stored selection if it's still in the list, otherwise falls back to the first group.
export const resolveSelectedGroup = groups => {
  const selectedId = getSelectedGroupId();
  return groups.find(group => group.group_id === selectedId) || groups[0] || null;
};

// Called on every signin: stores the groups and selects one for a Group Owner/Admin login,
// or clears any leftover group state for other logins.
export const startGroupSession = groups => {
  LEGACY_KEYS.forEach(key => localStorage.removeItem(key));
  storeGroups(groups);
  selectGroup(resolveSelectedGroup(groups));
};

export const clearGroupSession = () => {
  [GROUPS_KEY, SELECTED_GROUP_KEY, ...LEGACY_KEYS].forEach(key => localStorage.removeItem(key));
};

// Same as the sidebar's Logout.
export const signOut = () => {
  Object.keys(localStorage).forEach(key => {
    if (key !== 'existingPublishers') {
      localStorage.removeItem(key);
    }
  });
  window.location.replace('/login');
};
